// extracted by mini-css-extract-plugin
export default {"forgotPass":"TimerComponent_forgotPass__eaomu","logo":"TimerComponent_logo__fX+TX","btn":"TimerComponent_btn__1hgmU","timer":"TimerComponent_timer__Oqjh3"};